import { Box, Typography } from '@mui/material';
import React from 'react';
import { COLORS, Tooltip } from '@cellebrite/saas-ui-common';
import { Tag } from '../../models/common-types';

interface TagsViewerProps {
    checkedTags: Array<Tag>;
    styles?: any;
}

const TagsViewer: React.FC<TagsViewerProps> = ({ checkedTags, styles }) => {
    return !!checkedTags?.length ? (
        <Tooltip
            content={
                <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                    {checkedTags.map((tag, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box
                                sx={{
                                    width: 12,
                                    height: 12,
                                    backgroundColor: tag.color,
                                    borderRadius: 2,
                                    mr: 1,
                                }}
                            ></Box>
                            <Typography variant="s14w500">{tag.name}</Typography>
                        </Box>
                    ))}
                </Box>
            }
        >
            <Box
                sx={{
                    ...{ display: 'flex', justifyContent: 'center', position: 'relative', height: 24, width: 12 },
                    ...styles,
                }}
            >
                {checkedTags.map((tag, index) =>
                    index > 2 ? null : index === 2 ? (
                        <Box
                            key={index}
                            sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: COLORS.MUTED_LIGHTEST,
                                border: '1px solid #fff',
                                borderRadius: 2,
                                top: `${index * 6}px`,
                                position: 'absolute',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant="s12w500" className="color-mh">
                                +
                            </Typography>
                        </Box>
                    ) : (
                        <Box
                            key={index}
                            sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: tag.color,
                                border: '1px solid #fff',
                                borderRadius: 2,
                                top: `${index * 6}px`,
                                position: 'absolute',
                            }}
                        ></Box>
                    ),
                )}
            </Box>
        </Tooltip>
    ) : null;
};

export default TagsViewer;
